import { axiosClient } from '../axiosClient';

export const deleteUser = (userId: number) => {
  return axiosClient.delete(`/users/${userId}`);
};
